import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextArticle = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-5 text-md/[28px] last:mb-0 sm:mb-7 lg:text-lg/[31px]">
            {children}
        </p>
    )
}

export default CopytextArticle
